import React, { createContext, useContext, useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  // Initialize auth state from localStorage
  useEffect(() => {
    const storedUser = localStorage.getItem('user');
    if (storedUser) {
      setUser(JSON.parse(storedUser));
      setIsAuthenticated(true);
    }
    setLoading(false);
  }, []);

  const login = (data) => {
    // Store user data
    const userData = {
      id: data.id,
      firstName: data.first_name,
      lastName: data.last_name,
      email: data.email,
      userRole: data.user_role,
      isApprover: data.is_approver,
      isAdmin: data.is_admin,
      companyId: data.company_id,
      token: data.token
    };

    // Save to localStorage
    localStorage.setItem('user', JSON.stringify(userData));
    localStorage.setItem('token', data.token);
    localStorage.setItem('company', data.company_id.toString());
    localStorage.setItem('isLoggedIn', 'true');

    // Update context state
    setUser(userData);
    setIsAuthenticated(true);

    return userData;
  };

  const logout = () => {
    // Clear all auth data from localStorage
    localStorage.removeItem('user');
    localStorage.removeItem('token');
    localStorage.removeItem('company');
    localStorage.removeItem('isLoggedIn');

    // Reset context state
    setUser(null);
    setIsAuthenticated(false);

    // Redirect to login
    navigate('/login');
  };

  // Get stored auth token
  const getToken = () => {
    return localStorage.getItem('token');
  };

  // Get stored company ID
  const getCompanyId = () => {
    return localStorage.getItem('company');
  };

  return (
    <AuthContext.Provider 
      value={{
        user,
        isAuthenticated,
        loading,
        login,
        logout,
        getToken,
        getCompanyId
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

// Custom hook to use auth context
export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within an AuthProvider');
  }
  return context;
};

export default AuthContext;
